export default __webpack_public_path__ + "static/media/terms.d6599201.png";